import Resource from '@/plugins/sdk/Resource'
import { BOOLEAN, DATETIME, UUID, ITEM } from '@/plugins/sdk/fields'
import Account from '@/plugins/sdk/resources/Account'
import Group from '@/plugins/sdk/resources/RateSurcharge/Group'

export default class extends Resource {
  static name = 'ratesurcharge_index'

  static get fields () {
    return {
      id: new UUID(),
      date_start: new DATETIME(),
      date_end: new DATETIME(),
      active: new BOOLEAN(),
      deleted: new BOOLEAN(),
      deleted_date: new DATETIME(),
      account: new ITEM(Account),
      group: new ITEM(Group)
    }
  }
}
